const Routes = {
  test: '/test',
  authentication: {
    login: '/auth/login',
    isTempUser: '/auth/isTempUser',
  },
  base: '/',
  home: {
    student: '/home/student',
    teacher: '/home/teacher',
  },
};

export default Routes;
